module.exports = __webpack_public_path__ + "media/driving_style_de_ipad_air.7c04838f.mp4";